import { gql } from '@apollo/client';

export const DELETE_ADVERSE_EVENT = gql`
  mutation DeleteAdverseEvent($trackId: IdentifierType!, $adverseEventId: IdentifierType!) {
    deleteAdverseEvent(trackId: $trackId, adverseEventId: $adverseEventId) {
      result
    }
  }
`;
